import { render, staticRenderFns } from "./KnowledgeBaseDialogDelDoc.vue?vue&type=template&id=33fd1140&scoped=true&lang=pug&"
import script from "./KnowledgeBaseDialogDelDoc.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseDialogDelDoc.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeBaseDialogDelDoc.vue?vue&type=style&index=0&id=33fd1140&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fd1140",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
